// extracted by mini-css-extract-plugin
var _1 = "Line-K9LGM";
var _2 = "Separator-FJrkx";
export { _1 as "Line", _2 as "Separator" }
